export default {
    // App Title
    Title: "OUG Coach",
    // Menu settings
    MainMenu: [
        { icon: "mdi-home-outline", text: "Home", action: "./Home" },
        { icon: "mdi-account-multiple-outline", text: "People", action: "./People" },
        { icon: "mdi-school-outline", text: "Accreditation", action: "./Accreditation" },
        {
            icon: "mdi-chevron-up",
            "icon-alt": "mdi-chevron-down",
            text: "Resources",
            model: false,
            children: [
                { icon: "mdi-whistle-outline", text: "Drills", action: "./Drills" },
                { icon: "mdi-video-outline", text: "Videos", action: "./Videos" },
                { icon: "mdi-calendar-outline", text: "Calendar", action: "./Calendar" },
                {
                    icon: "mdi-file-document-multiple-outline",
                    text: "Documents",
                    action: "/Documents",
                },
                {
                    icon: "mdi-school-outline",
                    text: "Courses",
                    action: "/Courses",
                },
                // Old Courses/Documents Route
                // {
                //     icon: "mdi-school-outline",
                //     text: "Courses",
                //     action: "/Documents/Courses",
                // },
            ],
        },
        { icon: "mdi-certificate-outline", text: "My Certificates", action: "./Certificates" },
        { icon: "mdi-book-account-outline", text: "My Bookings", action: "./Bookings" },
        { icon: "mdi-message-alert-outline", text: "Player Feedback", action: "./Feedback" },
        { icon: "mdi-help-circle-outline", text: "Help", action: "/Help" },
        { icon: "mdi-information-outline", text: "About", action: "/About" },
    ],
    ProfileMenu: [
        { title: "Home", icon: "mdi-home-city", action: "./" },
        { title: "My Account", icon: "mdi-account", action: "./Account" },
        {
            title: "Help",
            icon: "mdi-help-circle-outline",
            action: "./Help",
        },
    ],
};